import { getOwnTemplatesFx } from 'stores/ownTemplates/model';
import { copyTemplateModalStore } from 'stores/modals/model';

import { copyTemplateFx } from './model';

copyTemplateFx.doneData.watch(() => {
    getOwnTemplatesFx(null);
    copyTemplateModalStore.closeModal();
});
